module.exports = "data:image/png;base64,UklGRo4BAABXRUJQVlA4WAoAAAAQAAAACgAADgAAQUxQSLAAAAAJl8KgbSRHn+xe+8Kf7jyLiMjLGsRgBn0Kuddjy7An2xCDP5EUg29VLyIyiRx3F6u62lDCYSTZpjXftu3/8G3bRv7BPAUR0f9EcVXinvu8d0MJn2oBp798imDdu3+dTOtt37oE2ytUH4nBh7mRRj6hXgUSHjboKzxvLOgOvjMK6EUWTVKyGVM1S/s8RLquL12mB/JvvFEf/yzKJ4mefqIu+6iDMXppxzGHMTaJowEAAFZQOCC4AAAAUAEAnQEqCwAPAAIANCWkAAT9gAD+9Zr8df7h/5///1TO8c/5Nv/k2+O/9Xp/v/+DX++f+Gt7//z/+x9/99/o/8zvyufr+//2Hz9yU74hssn/1z/EfLvkf+S85CXlzvP/57bVOP/+IMX5/kPiG3F/vDvlnPq/ix6jRtn//DXc/7Mt/n+xs8H+P/B/v/n90pKP4Ov/3X9Xfjtq7ECeWHTdSjYt9NjN4VqAp96/j///+02y7k/YBgAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/address-icon.png
// module id = /q5M
// module chunks = 171